export default "__VITE_ASSET__Bs$z7C8K__"